import React, {Component} from 'react';
import 'index.css';
import './Controls.css';
import './ProgressBar.scss';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import Tooltip from '../Tooltip';

import 'react-tooltip/dist/react-tooltip.css';

momentDurationFormatSetup(moment);

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      targetPosition: 0,
      targetOn: false,
      timeTarget: '0',
      tooltipOffset: 0,
    };
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.fromPositionToDuration = this.fromPositionToDuration.bind(this);
    this.progressBarRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('mouseup', this.handleMouseUp);
    document.addEventListener('mousemove', this.handleMouseMove);
  }
  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('mousemove', this.handleMouseMove);
  }

  fromPositionToDuration(position) {
    return moment.duration(this.props.duration * position, 'seconds').format('h:mm:ss', {stopTrim: 'h'});
  }

  handleMouseDown(e) {
    e.stopPropagation();
    let {direct, directMin} = this.props;
    let node = this.progressBarRef.current;
    let rect = node.getBoundingClientRect();
    let p = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
    if (p >= directMin && p <= direct)
      this.setState({
        moveStartPosition: p,
        targetPosition: p,
        targetCurrentTime: p * this.props.duration,
        targetOn: true,
      });
  }
  handleMouseMove(e) {
    e.stopPropagation();
    let {targetOn, moveStartPosition} = this.state;
    let {direct, directMin, duration} = this.props;

    const node = this.progressBarRef.current;
    let rect = node.getBoundingClientRect();
    let mp = (e.clientX - rect.left) / rect.width;

    if (targetOn) {
      let p = Math.min(1, Math.max(0, moveStartPosition + 1 * (mp - moveStartPosition)));
      if (direct) p = Math.max(directMin, Math.min(p, direct));
      this.setState({
        targetPosition: p,
        targetCurrentTime: p * duration,
        timeTarget: this.fromPositionToDuration(mp),
        tooltipOffset: mp,
      });
    } else {
      this.setState({
        timeTarget: this.fromPositionToDuration(mp),
        tooltipOffset: mp,
      });
    }
  }
  handleMouseUp(e) {
    e.stopPropagation();
    if (this.state.targetOn) {
      this.setState({targetOn: false});
      this.props.onPositionUpdate(this.state.targetPosition);
    }
  }
  render() {
    const {currentTime, duration} = this.props;
    let progressStyle = {width: (currentTime / duration) * 100 + '%'};
    let directStyle = this.props.direct ? {width: this.props.direct * 100 + '%'} : {};
    let targetStyle = {left: this.state.targetPosition * 100 - 0.25 + '%'};
    let targetClass = 'controls-progressbar-target';
    if (this.state.targetOn) {
      targetClass += ' on';
    }
    return (
      <Tooltip
        visible={this.props.withTooltip}
        offset={this.state.tooltipOffset}
        title={this.state.timeTarget}
        id="time-tooltip"
        placement="top"
      >
        <div className="controls-progressbar-container" onClick={e => e.stopPropagation()}>
          {this.props.visibleTimestamp && (
            <div className="controls-progressbar-time">
              {moment.duration(this.props.currentTime, 'seconds').format('h:mm:ss', {stopTrim: 'h'})} /{' '}
              {moment.duration(this.props.duration, 'seconds').format('h:mm:ss', {stopTrim: 'h'})}
            </div>
          )}
          <div className="controls-progressbar-background">
            {Boolean(this.props.direct) && <div className="controls-progressbar-direct" style={directStyle}></div>}
            <div className="controls-progressbar-progress" style={progressStyle}></div>
            <div className={targetClass} style={targetStyle}></div>
          </div>
          <div
            className="controls-progressbar-mask"
            ref={this.progressBarRef}
            onMouseDown={!this.props.moveDisabled ? this.handleMouseDown : undefined}
          ></div>
        </div>
      </Tooltip>
    );
  }
}
export default ProgressBar;
